export const getShowHugggLife = ({
  theme,
  isBlueHuggg,
  isRedeemed,
  hasVouchers,
  isInIframe
}) => {
  return (
    (!theme || theme === 'default') &&
    !isBlueHuggg &&
    (isRedeemed || hasVouchers) &&
    !isInIframe()
  );
};

// If it doesn't exist or it is less than 30 seconds old, it is the first redemption
// A bit hacky but more reliable than checking if the huggg has been redeemed
export const getFirstRedemption = huggg => {
  try {
    const redeemedCreatedAt = huggg?.redeemed?.created_at;
    if (!redeemedCreatedAt) return true;

    const redeemedAtDate = new Date(redeemedCreatedAt);
    return redeemedAtDate.getSeconds() < 15;
  } catch (e) {
    return false;
  }
};

export const getShowReaction = ({
  hasReaction,
  isFirstRedemption,
  hasVoucherToClaim,
  isRedeemed,
  hasVouchers
}) =>
  !hasReaction &&
  isFirstRedemption &&
  !hasVoucherToClaim &&
  (isRedeemed || hasVouchers);
